import Backbone from 'backbone'
import template from './schedule.hbs'
import _ from 'lodash'
import i18n from 'scoreboard/components/i18n'
import ScheduleWarning from '../schedule-warning'
import { getScheduleStatusIconAndColor } from '../status-icon-and-color'
import { BEHIND_RED, BEHIND_YELLOW } from '../schedule-status'

var Schedule = Backbone.View.extend({

	// this.model is the Initiative
	className: 'panel icon-panel',

	initialize: function() {
		this.model.on('change:projectedSchedule', this.render.bind(this))
	},

	render: function() {
		let projectedSchedule = this.model.get('projectedSchedule')
		this.$el.empty().append(template(this.context()))

		this.scheduleWarning = new ScheduleWarning({ model: this.model })
		this.$('.panel-header').append(this.scheduleWarning.el)
		this.scheduleWarning.render()

		this.$('.panel-header').toggleClass('has-warning', this.scheduleWarning.showing())

		var status = _.result(projectedSchedule, 'status')
		this.$el.toggleClass('has-no-status-data', status === 'no-data')

		let pastDueDateStatus = this.model.getPastDueDateStatus()
		this.$('.info-wrapper')
			.toggleClass('is-forced-red-status',
				pastDueDateStatus === BEHIND_RED)
			.toggleClass('is-forced-yellow-status',
				pastDueDateStatus === BEHIND_YELLOW)

		return this
	},

	context() {
		let projectedSchedule = this.model.get('projectedSchedule')
		var complete = !!this.model.get('aggregatedCompletionDate')
		var completionSuffix = complete ? '.completed' : ''

		let ctx = _.extend({
			headerLabel: 'initiatives.projectedSchedule' + completionSuffix,
			endDateLabel: 'initiatives.projectedEndDate' + completionSuffix
		}, this.model.attributes)

		let status = _.result(projectedSchedule, 'status')
		if (status === 'no-data') {
			ctx.projectedSchedule.descriptiveMessage = projectedSchedule?.projectedEndDate
				// #50870 give a slightly clearer message when we are already
				// showing a projected end date
				? i18n.get('initiatives.projectedSchedule.noData.projectedShowing')
				: i18n.get('initiatives.projectedSchedule.noData')
		}

		_.extend(ctx, getScheduleStatusIconAndColor(this.model))

		return ctx
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this.scheduleWarning], 'remove')
	}
})

export default Schedule

Schedule.__filename__ = 'initiatives/overview/schedule.js'
